import React, { Component } from "react";
import PropTypes from "prop-types";
import Konva from "konva";
import WheelItem from "./WheelItem";
import NameRoulette from "./NameRoulette";
import WheelLever from "./WheelLever";
import WheelArrow from "./WheelArrow";
import WheelSpinner from "./WheelSpinner";
/**
 * TODO:  Exposed API :
 * 1. Diameter ✔️
 * 2. Maximum Duration ✔️
 * 3. onSelect callback ✔️
 *
 * Feature:
 * 1. Responsive ✔️
 *
 * @augments {Component<Wheel.propTypes, {}>}
 */
class Wheel extends Component {
  static propTypes = {
    // Overall canvas diameter. Default is 500
    diameter: PropTypes.number,

    // Maximum duration for the spinner (in milliseconds). Default is 5 second
    maximumDuration: PropTypes.number,

    // Maximum duration for the spinner (in milliseconds). Default is 300ms
    minimumDuration: PropTypes.number,

    // The category data
    data: PropTypes.array.isRequired,

    /**
     * Callback when the spinner is stop, and get the selected category, it
     * will pass parameter one parameter (name)
     */
    onSelectedPlayer: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    buttonText: PropTypes.string,
    buttonLogo: PropTypes.string,
    buttonColor: PropTypes.string,
    buttonBg: PropTypes.string,
    textStyle: PropTypes.object
  };

  static defaultProps = {
    diameter: 500,
    maximumDuration: 3000,
    minimumDuration: 300,
    onSelect: id => {},
    buttonLogo: "redo-alt",
    buttonText: "Spin",
    isCustomLogo: false,
    onSelectedPlayer: name => {}
  };

  constructor(props) {
    super(props);
    this.state = {
      rotation: 0,
      diameter: props.diameter,
      isSpinning: false,
      duration: 0,
      isLevel: "",
      isVertical: false
    };

    this.wrapper = React.createRef();
    this.animateLayer = React.createRef();
    this.animateGroup = React.createRef();
    this.forceLever = React.createRef();
  }

  registerTickSound = new Audio(
    "https://res.cloudinary.com/drtnbid6h/video/upload/v1641880582/tick_mpn0xo.mp3"
  );

  componentDidMount() {
    this.updateDiameter();
    window.addEventListener("resize", this.updateDiameter);

    if (this.props.data.length > 6) {
      this.setState({
        isVertical: true
      });
    } else {
      this.setState({
        isVertical: false
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDiameter);
  }

  updateDiameter = () => {
    /**
     * configDiameter is the desired diameter that passed via props, not from
     * current state, if the desired diameter is too big then resize canvas to
     * maximum possible layout instead
     */

    const configDiameter = this.props.diameter;
    const wrapperSize = this.wrapper.current
      ? this.wrapper.current.clientWidth
      : 0;

    if (wrapperSize === 0) {
      const newDiameter = 500;
      this.setState({
        diameter: newDiameter,
        isVisualCheck: true
      });
    } else {
      const newDiameter = Math.min(configDiameter, wrapperSize);
      const shouldUpdate = newDiameter !== this.state.diameter;

      if (shouldUpdate) {
        this.setState({
          diameter: newDiameter,
          isVisualCheck: true
        });
      }
    }
  };

  spin = () => {
    this.setState({
      isSpinning: true
    });

    const { offsetLeft } = this.forceLever.current;
    let forcePower = offsetLeft / 100;

    if (offsetLeft <= 5) {
      forcePower = 0.2;
      this.setState({
        isLevel: "LOW"
      });
    } else if (offsetLeft >= 6 && offsetLeft <= 20) {
      forcePower = 0.5;
      this.setState({
        isLevel: "MEDIUM"
      });
    } else if (offsetLeft >= 21 && offsetLeft <= 40) {
      forcePower = 1;
      this.setState({
        isLevel: "HIGH"
      });
    } else if (offsetLeft >= 41 && offsetLeft <= 50) {
      forcePower = 0.5;
      this.setState({
        isLevel: "MEDIUM"
      });
    } else if (offsetLeft >= 50) {
      forcePower = 0.2;
      this.setState({
        isLevel: "LOW"
      });
    }

    const animateLayer = this.animateLayer.current;
    const animateGroup = this.animateGroup;
    const props = this.props;
    const state = this.state;
    const thisSetState = params => this.setState({ ...params });

    // const speedForce = 5 + 10 * random; //old random speedforce
    const speedForce = 5 + 10 * forcePower;

    const _randomDuration = (speedForce * 1000) / 2;
    const _maxDuration = props.maximumDuration;
    const _minDuration = props.minimumDuration;

    // Make sure the duration is not longer than the maximum limit
    const _notTooLong = Math.min(_randomDuration, _maxDuration);

    // Make sure the duration is not too short than the minimum limit
    const _notTooShort = Math.max(_notTooLong, _minDuration);

    const duration = _notTooShort;

    // set duration to state
    thisSetState({ duration: duration });

    // TODO: Remove
    // console.log(
    //   "duration: ",
    //   duration,
    //   "\nrandom-duration: ",
    //   _randomDuration,
    //   "\nspeedForce: ",
    //   speedForce,
    // );

    // Get Index
    let activeIndex = 0;
    const categories = this.props.data;

    const eachItemAngle = Math.floor(360 / categories.length);
    const getIndex = ang => {
      const deg = ang % 360;
      const index = Math.floor(deg / eachItemAngle);
      return {
        index,
        value: categories[index]
      };
    };

    const animationPromise = new Promise((resolve, reject) => {
      const animation = new Konva.Animation(function(frame) {
        const time = frame.time;
        const theta = ((duration - time) * speedForce) / duration;

        /**
         * if time value have not reach or higher than the duration, then
         * continue to spin, otherwise times is up and stop spinning
         */
        if (time < duration) {
          animateGroup.current.rotate(theta);
          const angle = animateGroup.current.rotation();
          const newIndex = getIndex(angle).index;

          if (newIndex !== activeIndex) {
            activeIndex = newIndex;
            // playTick();
          }
        } else {
          this.stop();

          /**
           * Get the element that right in the center of Layer, and exactly in
           * the first offset of the canvas, it could be Arc, could be Image or
           * Text, so make sure all of the three component have attribute name
           * for safety reason
           */

          const selectedElement = animateLayer.getIntersection({
            x: state.diameter / 2,
            y: 1
          });

          const selectedId = selectedElement.attrs.name;
          // console.log("selectedElement:" + selectedElement);
          thisSetState({ isSpinning: false });

          resolve(props.onSelect(selectedId));
          // console.log("selectedId:" + selectedId);
        }
      }, animateLayer);
      animation.start();
    });

    return animationPromise;
  };

  preventMoreThanItShould = () => {  
    if (this.props.currentTime < 0) {
      this.props.isMaxAlert();
    } else {
      this.spin();
    }
  };

  render() {
    const items = this.props.data;
    const totalItems = items.length;

    /**
     * Overall diameter of a spinner, everything attached to this size, so if
     * you change this it will also maintain the ratio of all the item inside
     * the canvas
     */
    const diameter = this.state.diameter;
    const radius = diameter / 2;

    const isVertical = this.state.isVertical;

    const renderWheelItems = items.map((item, index) => (
      <WheelItem
        key={index}
        diameter={diameter}
        radius={radius}
        totalItems={totalItems}
        index={index + 1}
        data={item}
        textStyle={this.props.textStyle}
        isVertical={isVertical}
      />
    ));

    return (
      <>
        <div
          className="v2-wheel"
          ref={this.wrapper}
          style={{ width: diameter }}
        >
          <div className="v2-wheel-left-side">
            <NameRoulette
              duration={this.state.duration}
              members={this.props.members}
              onSelectedPlayer={this.props.onSelectedPlayer}
              isSpinning={this.state.isSpinning}
              result={this.props.result}
            />
            <WheelArrow isSpinning={this.state.isSpinning} />
          </div>
          <WheelSpinner
            diameter={diameter}
            isSpinning={this.state.isSpinning}
            animateLayer={this.animateLayer}
            radius={radius}
            animateGroup={this.animateGroup}
            renderWheelItems={renderWheelItems}
          />
          <WheelLever
            className={this.state.isSpinning ? "active" : ""}
            onClick={this.preventMoreThanItShould}
            disabled={this.state.isSpinning}
            isSpinning={this.state.isSpinning}
            isLevel={this.state.isLevel}
            isOpenQuestion={this.props.isOpenQuestion}
            ref={this.forceLever}
          />
        </div>
      </>
    );
  }
}

export default Wheel;
